import React, {PureComponent} from 'react'
import { connect } from 'react-redux'
import injectStyles from "react-jss"
import headphones from "../../img/icons/headphones-mic.svg"
import question from "../../img/icons/question-circle.svg"
import truck from "../../img/icons/truck.svg"
import refresh from "../../img/icons/refresh.svg"
import cursor from "../../img/icons/cursor.svg"
import uservoice from "../../img/icons/uservoice.svg"
import gift from "../../img/icons/gift.svg"
import SVGSymbol from "../SVGSymbol"
import {getExtraNavItems} from "../../selectors"

const _icons = {
    headphones,
    question,
    truck,
    refresh,
    cursor,
    uservoice,
    gift
}

class ExtraNav extends PureComponent {

    _getIcon = (name) => {
        return _icons[name];
    }

    render() {
        const {classes, extraNavItems} = this.props;
        if(!extraNavItems) return null;

        return <div className={classes.wrapper}>
            <div className='row'>
                <nav className={classes.navWrapper}>
                    <ul>
                        {extraNavItems.map(item => (
                            <li key={item.url}>
                                <a className="ga-track-link-click" href={item.url} data-ga-category={item.ga_category} data-ga-action={item.ga_action} data-ga-label={item.ga_label} >
                                    <SVGSymbol icon={this._getIcon(item.icon)} className={classes.icon} />
                                    {item.title}
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>
            </div>
        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        extraNavItems: getExtraNavItems(state),
    }
}

export default injectStyles((theme) => ({
    wrapper: {
        zIndex: theme.zIndex.menu,
        background: theme.colors.white,
        position: 'relative',
        display: "none",
        [theme.breakpoint('laptop')]: {
            display: "block"
        }
    },
    navWrapper: {
        paddingLeft: theme.convertFromIconicRemValue(0.5),
        paddingRight: theme.convertFromIconicRemValue(0.5),
        "& ul": {
            //fontFamily: "Proxima Nova Light",
            margin: 0,
            padding: `${theme.convertFromIconicRemValue(0.3125)} 0 ${theme.convertFromIconicRemValue(0.125)}`,
            textAlign: 'right',
            lineHeight: theme.convertFromIconicRemValue(1.125),
        },
        "& ul li": {
            listStyle: 'none',
            display: 'inline-block',
            marginRight: '1rem',
            fontSize: theme.convertFromIconicRemValue(0.875),
            lineHeight: theme.convertFromIconicRemValue(1.25),
            paddingBottom: theme.convertFromIconicRemValue(0.125),
        },
        "& ul li a": {
            color: '#AFAFAF',
            textDecoration: 'none',
        },
        "& ul li a:hover": {
            color: '#232323'
        }
    },
    icon: {
        width: 14,
        height: 14,
        display: 'inline-block',
        verticalAlign: 'middle',
        position: 'relative',
        top: '-.1em',
        marginRight: 3
    }

}))(connect(mapStateToProps)(ExtraNav))



// WEBPACK FOOTER //
// ./src/components/UniversalNav/ExtraNav.js